import { Component, OnInit } from "@angular/core";
import { ViewController, NavParams } from "ionic-angular";
import { DiaprofilPatient } from "../../app/models/diaprofil-patient";
import { DiaprofilProTask } from "../../app/models/diaprofil-pro-task";
import { WidgetConfig } from "@zitelab/ionic-fhir-questionnaires/dist/models/widget";
import {
  QuestionnaireService,
  QuestionnaireState,
  QuestionnaireResponseService,
  AnswerInfo,
  ExtractedItemAnswer
} from "@zitelab/ionic-fhir-questionnaires";
import { FhirService } from "../../app/services/fhir.service";
import {
  DIAPROFIL_QUESTIONNAIRE_UUID,
  KRAM_QUESTIONNAIRE_UUID
} from "../../app/models/types";
import * as QuestionnaireActions from "@zitelab/ionic-fhir-questionnaires/dist/";
import { diaprofilEnableWhenFunctions } from "../../app/utils/enable-when-functions";
import { DashboardService } from "../../app/services/dashboard.service";
import { TranslateService } from "@ngx-translate/core";
import { compare } from "fast-json-patch";
import { ToastController } from "ionic-angular/components/toast/toast-controller";
import { _i18n_str } from "../../assets/i18n/non-static-ids";
import { Observable } from "rxjs/Observable";
import * as moment from "moment";
import { switchMap, map } from "rxjs/operators";
import { of } from "rxjs/observable/of";

@Component({
  selector: "all-answers-modal",
  templateUrl: "all-answers.modal.html"
})
export class AllAnswersModal implements OnInit {
  patient: DiaprofilPatient;
  proTask: DiaprofilProTask;
  answers: ExtractedItemAnswer[] = null;
  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public translate: TranslateService,
    public questionnaireService: QuestionnaireService,
    public dashboard: DashboardService,
    public fhir: FhirService,
    public toastCtrl: ToastController,
    public questionnaireResponseService: QuestionnaireResponseService
  ) {
    this.patient = (navParams.get("patient") || {}) as DiaprofilPatient;
    this.proTask = (navParams.get("proTask") || null) as DiaprofilProTask;
  }

  ngOnInit(): void {
    const answersObj = this.questionnaireResponseService.extractAnswersFromQuestionnaireResponse(
      this.proTask.response
    );
    this.answers = Object.keys(answersObj).map(linkId => answersObj[linkId]);
    console.log(this.answers);
  }

  dismiss($event) {
    this.viewCtrl.dismiss();
  }

  handleFormChange(form) {
    console.log("handleFormChange");
  }

  handleFormSubmit(event, form) {
    this.viewCtrl.dismiss();
  }

  toPreviousPage(event) {}
}



// WEBPACK FOOTER //
// ./src/modals/all-answers.modal/all-answers.modal.ts